import React, { PropTypes } from 'react';

export default class ObservationRecordFrame extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
    };
    // bind this
  }

  render() {
    return (
      <div className="development-frame">
        {this.props.children}
      </div>
    )
  }
} 


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/development/ObservationRecordFrame.jsx